import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import egam from "../../services/egam";
import { getClientData } from "../../services/auth";
import { queryKeys } from "../api/queryKeys";
import { IntervaloParams, IntervaloResponse } from "../../types/Parcelamento";

export const useIntervalo = (
  params: IntervaloParams | null,
  enabled: boolean = true
) => {
  return useQuery<IntervaloResponse>({
    queryKey: queryKeys.intervalo(params),
    queryFn: async () => {
      if (!params || !params.parcela) {
        throw new Error("Parâmetros não fornecidos");
      }

      const clientData = getClientData();
      if (!clientData) {
        throw new Error("Cliente não autenticado");
      }

      const formData = new FormData();
      formData.append("pedidoExterno", "true");
      formData.append("totalLiquido", params.totalLiquido.toFixed(2));
      formData.append("totalMedicamentos", params.totalMedicamentos.toFixed(2));
      formData.append("totalPerfumaria", params.totalPerfumaria.toFixed(2));
      formData.append("NR_PARCELAS", params.parcela);

      const response = await egam.post<IntervaloResponse>(
        "pedidos/finalizar/parcelamento/parcelas",
        formData
      );

      if (response.data && response.data.msg_err) {
        const errorMsg = String(response.data.msg_err);
        toast.error(errorMsg);
        throw new Error(errorMsg);
      }

      return response.data;
    },
    enabled: enabled && params !== null && params.parcela !== "",
    staleTime: 0, // Sempre refetch quando os parâmetros mudarem
    refetchOnMount: "always", // Sempre refetch quando o componente montar
  });
};
